import * as React from "react"
import { usePage } from "@inertiajs/react"
import {
  BookOpen,
  Building2,
  Home,
  Infinity as InfinityIcon,
  KeyRound,
  Package,
  Palette,
  RefreshCw,
  Users,
} from "lucide-react"
import { ImpersonationBanner } from "@/components/ImpersonationBanner"
import { MainNav, type NavItemDef } from "@/components/MainNav"
import type { PageProps } from "@/types/inertia"

const ADMIN_NAV_ITEMS: NavItemDef[] = [
  {
    href: "/",
    icon: Home,
    label: "App Home",
    match: () => false,
  },
  {
    href: "/admin/accounts",
    icon: Building2,
    label: "Accounts",
    match: (url) => url.startsWith("/admin/accounts"),
  },
  {
    href: "/admin/subscriptions",
    icon: RefreshCw,
    label: "Subscriptions",
    match: (url) => url.startsWith("/admin/subscriptions"),
  },
  {
    href: "/admin/licenses",
    icon: KeyRound,
    label: "Licenses",
    match: (url) => url.startsWith("/admin/licenses"),
  },
  {
    href: "/admin/lifetime_deals",
    icon: InfinityIcon,
    label: "Lifetime Deals",
    match: (url) => url.startsWith("/admin/lifetime_deals"),
  },
  {
    href: "/admin/releases",
    icon: Package,
    label: "Releases",
    match: (url) => url.startsWith("/admin/releases"),
  },
  {
    href: "/admin/users",
    icon: Users,
    label: "Users",
    match: (url) => url.startsWith("/admin/users"),
  },
  {
    href: "/admin/docs",
    icon: BookOpen,
    label: "Admin Docs",
    match: (url) => url.startsWith("/admin/docs"),
  },
  {
    href: "/admin/design-system",
    icon: Palette,
    label: "Design System",
    match: (url) => url.startsWith("/admin/design-system"),
  },
]

export function AdminShell({ children }: { children: React.ReactNode }) {
  const { props } = usePage<PageProps>()

  return (
    <div className="flex min-h-screen flex-col bg-page text-ink-body">
      <ImpersonationBanner />
      <div className="flex min-h-0 flex-1">
        <MainNav items={ADMIN_NAV_ITEMS} brandHref="/admin/accounts" />
        <main className="min-w-0 flex-1 px-6 py-8 sm:px-10">
          <div className="mx-auto max-w-4xl">
            {(props.flash?.notice || props.flash?.alert) && (
              <div className="mb-6 space-y-2">
                {props.flash.notice && (
                  <div className="callout callout-accent">
                    <p>{props.flash.notice}</p>
                  </div>
                )}
                {props.flash.alert && (
                  <div className="callout callout-danger">
                    <p>{props.flash.alert}</p>
                  </div>
                )}
              </div>
            )}
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}
